




























/**
 * The Console component displays log messages.
 */

import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import { LogLevel } from '../lib/LogLevel'

@Component
export default class Console extends Vue {
  @Prop() private msg!: string

  get logs() {
    return this.$store.state.logs
  }

  applyLevelError() {
    this.$store.dispatch('setLogLevel', LogLevel.ERROR)
  }
  applyLevelInfo() {
    this.$store.dispatch('setLogLevel', LogLevel.INFO)
  }
  applyLevelDebug() {
    this.$store.dispatch('setLogLevel', LogLevel.DEBUG)
  }

  getReadableLevel() {
    switch (this.$store.state.logLevel) {
      case LogLevel.ERROR:
        return 'Error'
      case LogLevel.INFO:
        return 'Info'
      case LogLevel.DEBUG:
        return 'Debug'
    }
  }
}
